module.exports = __webpack_public_path__ + "img/扶梯3.4ffab0a0.png";